import { log } from "../utils/logger";

export default function generateDataFilter(data, filter) {
  log(`%c[+] Generating mock[DATA.FILTER] for filter[${filter}]`, "color: green");

  // Exported Array
  const SAMPLE_DATA = [];

  // Incrementing tracker
  let pk_id_bint = 1;

  data.forEach((dataRecord) => {
    const already_registered = SAMPLE_DATA.find((record) => {
      return record.value_vch === dataRecord[filter];
    });

    if (already_registered) {
      already_registered._count++;
      return;
    }

    const sample_record = {
      pk_id_bint: pk_id_bint++,
      filter_id_bint: 1,
      value_vch: dataRecord[filter], // Name of the filter being searched. i.e. city, circuit, etc
      _count: 1, // Suggested meta-data
    };

    SAMPLE_DATA.push(sample_record);
  });

  return SAMPLE_DATA;
}
